export default "__VITE_ASSET__CK4eP9Yv__"